import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'merc... Remove this comment to see the full error message
import ValidProducts from 'merchandise-lib/constants/Product';
export const EDITIONS = {
  FREE: 'free',
  STARTER: 'starter',
  PROFESSIONAL: 'professional',
  ENTERPRISE: 'enterprise'
};
const {
  SALES,
  MARKETING,
  SERVICE,
  OPS,
  CMS
} = ONBOARDING_VIEWS;
const {
  STARTER,
  PROFESSIONAL,
  ENTERPRISE
} = EDITIONS;
export const productEditionData = {
  // sales
  [ValidProducts.SALES_HUB_STARTER]: {
    hub: SALES,
    edition: STARTER
  },
  [ValidProducts.SALES_HUB_STARTER_ONBOARDING]: {
    hub: SALES,
    edition: STARTER
  },
  [ValidProducts.SALES_HUB_PROFESSIONAL]: {
    hub: SALES,
    edition: PROFESSIONAL
  },
  [ValidProducts.SALES_HUB_PROFESSIONAL_ONBOARDING]: {
    hub: SALES,
    edition: PROFESSIONAL
  },
  [ValidProducts.SALES_HUB_ENTERPRISE]: {
    hub: SALES,
    edition: ENTERPRISE
  },
  [ValidProducts.SALES_HUB_ENTERPRISE_ONBOARDING]: {
    hub: SALES,
    edition: ENTERPRISE
  },
  // marketing
  [ValidProducts.MARKETING_HUB_STARTER]: {
    hub: MARKETING,
    edition: STARTER
  },
  [ValidProducts.MARKETING_HUB_STARTER_ONBOARDING]: {
    hub: MARKETING,
    edition: STARTER
  },
  [ValidProducts.MARKETING_HUB_PROFESSIONAL]: {
    hub: MARKETING,
    edition: PROFESSIONAL
  },
  [ValidProducts.MARKETING_HUB_PROFESSIONAL_ONBOARDING]: {
    hub: MARKETING,
    edition: PROFESSIONAL
  },
  [ValidProducts.MARKETING_HUB_PROFESSIONAL_ONBOARDING_LATAM]: {
    hub: MARKETING,
    edition: PROFESSIONAL
  },
  [ValidProducts.MARKETING_HUB_ENTERPRISE]: {
    hub: MARKETING,
    edition: ENTERPRISE
  },
  [ValidProducts.MARKETING_HUB_ENTERPRISE_LEGACY_FEATURES]: {
    hub: MARKETING,
    edition: ENTERPRISE
  },
  [ValidProducts.MARKETING_HUB_ENTERPRISE_ONBOARDING]: {
    hub: MARKETING,
    edition: ENTERPRISE
  },
  [ValidProducts.MARKETING_HUB_ENTERPRISE_ONBOARDING_LATAM]: {
    hub: MARKETING,
    edition: ENTERPRISE
  },
  // service
  [ValidProducts.SERVICE_HUB_STARTER]: {
    hub: SERVICE,
    edition: STARTER
  },
  [ValidProducts.SERVICE_HUB_STARTER_ONBOARDING]: {
    hub: SERVICE,
    edition: STARTER
  },
  [ValidProducts.SERVICE_HUB_PROFESSIONAL]: {
    hub: SERVICE,
    edition: PROFESSIONAL
  },
  [ValidProducts.SERVICE_HUB_PROFESSIONAL_ONBOARDING]: {
    hub: SERVICE,
    edition: PROFESSIONAL
  },
  [ValidProducts.SERVICE_HUB_ENTERPRISE]: {
    hub: SERVICE,
    edition: ENTERPRISE
  },
  [ValidProducts.SERVICE_HUB_ENTERPRISE_ONBOARDING]: {
    hub: SERVICE,
    edition: ENTERPRISE
  },
  // ops
  [ValidProducts.OPERATIONS_HUB_STARTER]: {
    hub: OPS,
    edition: STARTER
  },
  [ValidProducts.OPERATIONS_HUB_PROFESSIONAL]: {
    hub: OPS,
    edition: PROFESSIONAL
  },
  [ValidProducts.OPERATIONS_HUB_ENTERPRISE]: {
    hub: OPS,
    edition: ENTERPRISE
  },
  // cms
  [ValidProducts.CMS_HUB_STARTER]: {
    hub: CMS,
    edition: STARTER
  },
  [ValidProducts.CMS_HUB_PROFESSIONAL]: {
    hub: CMS,
    edition: PROFESSIONAL
  },
  [ValidProducts.CMS_HUB_PROFESSIONAL_ONBOARDING]: {
    hub: CMS,
    edition: PROFESSIONAL
  },
  [ValidProducts.CMS_HUB_ENTERPRISE]: {
    hub: CMS,
    edition: ENTERPRISE
  },
  [ValidProducts.CMS_HUB_ENTERPRISE_ONBOARDING]: {
    hub: CMS,
    edition: ENTERPRISE
  }
};

// TODO: Remove this once https://git.hubteam.com/HubSpot/setup-guide-ui/pull/3070 is merged

export const getProductEditionData = product => {
  const productEdition = productEditionData[product];
  if (!productEdition) {
    return {
      hub: undefined,
      edition: undefined
    };
  }
  return productEdition;
};